<template>
  <PrintPageLandscape>
    <PresentationPage :page-number="pageNumber" :page-count="pageCount">
      <p class="presentation-page__eyebrow">Ihr Vorteil</p>

      <h2 class="presentation-page__title">Was Sie davon haben</h2>

      <p class="presentation-page__text">
        Sechs Gründe, warum Kunden uns als Partner wählen — und seit Jahren bleiben.
      </p>

      <div class="presentation-page__highlights">
        <article
          v-for="benefit in benefits"
          :key="benefit.heading"
          class="presentation-page__highlight-card"
        >
          <div
            class="presentation-page__highlight-icon presentation-page__highlight-icon--circle"
            aria-hidden="true"
          >
            <i class="fa fa-check"></i>
          </div>
          <h3 class="presentation-page__highlight-heading">{{ benefit.heading }}</h3>
          <p class="presentation-page__highlight-text">{{ benefit.text }}</p>
        </article>
      </div>
    </PresentationPage>
  </PrintPageLandscape>
</template>

<script>
import PrintPageLandscape from '@/components/Print/PrintPageLandscape.vue';
import PresentationPage from '@/views/MasterPresentation/PresentationPage';

export default {
  name: 'MasterPresentationPrintPage16',

  components: {
    PrintPageLandscape,
    PresentationPage,
  },

  props: {
    project: { type: Object, default: null },
    pageCount: { type: Number, default: null },
    pageNumber: { type: Number, default: 0 },
  },

  data() {
    return {
      benefits: [
        {
          heading: 'Ein Ansprechpartner',
          text: 'Sie reden mit einer Person. Im Hintergrund laufen alle Gewerke koordiniert ab.',
        },
        {
          heading: 'Kein technisches Risiko',
          text:
            'e way übernimmt Garantie, Versicherung und Service über 20 Jahre — schlüsselfertig.',
        },
        {
          heading: 'Kein Verwaltungsaufwand',
          text: 'ReTIS erledigt Abrechnung, Dokumentation und Behördenkommunikation digital.',
        },
        {
          heading: 'Flexible Modelle',
          text:
            'Sie wählen: kaufen, verpachten, Mieterstrom anbieten, oder als Investor mitmachen.',
        },
        {
          heading: 'Klare Zahlen',
          text:
            'Wir rechnen Ihnen vorab vor, was Sie verdienen oder sparen — transparent und konservativ.',
        },
        {
          heading: 'Langfristige Partnerschaft',
          text:
            '20+ Jahre gemeinsam — mit Vertragssicherheiten, die Banken und Behörden anerkennen.',
        },
      ],
    };
  },
};
</script>
